import {addClickHandler} from "@/layouts/documentClickHandler.js";
import {domLoader} from "@/loader.js";
import {debug} from "@/debug.js";

window.initText = false
domLoader(function () {
  if (window.initText) return
  window.initText = true
  debug.log("init text loaded")

  let isIframeHover = null;
  let isXHintOver = null;

  function scrollToContentHeader(header) {
    if (!header) {
      return
    }

    document.querySelectorAll(".header.active").forEach(element => {
      element.classList.remove("active", "color1", "color2")
    })

    let isDesktop = window.innerWidth > 1024
    let top = window.scrollY - (isDesktop ? 128 : 64)
    let y = header.getBoundingClientRect().top + top

    header.classList.add("active")

    let interval = setInterval(function () {
      if (header.classList.contains("active")) {
        if (header.classList.contains("color1")) {
          header.classList.remove("color1")
          header.classList.add("color2")
        } else {
          header.classList.remove("color2")
          header.classList.add("color1")
        }
      } else {
        clearInterval(interval)
        header.classList.remove("color2", "color1")
      }
    }, 300)

    setTimeout(function () {
      header.classList.remove("active", "color2", "color1")
    }, 2400)

    window.scrollTo({top: y, behavior: "smooth"})
  }

  addClickHandler(".head_li", function (event) {
    try {
      let link = event.target.closest(".head_li") || event.target

      let tabDescription = document.getElementById("tab-description")
      if (tabDescription && !tabDescription.classList.contains("show")) {
        document.querySelectorAll(".vmpi").forEach(el => el.remove())
        tabDescription.classList.add("show")
      }

      let targetId = link.getAttribute("data-target")
      if (targetId) {
        scrollToContentHeader(document.getElementById(targetId))
        return
      }

      let scope = link.closest("#tab-description, .article-container, .blog-single__article")
      let id = link.getAttribute("id")
      if (!scope || !id) {
        return
      }

      scope.querySelectorAll(".x-text h2").forEach(h2 => {
        if (!h2.classList.contains("header")) {
          h2.classList.add("header")
        }
      })

      let headers = scope.querySelectorAll(".x-text h2.header")
      scrollToContentHeader(headers[parseInt(id.replace("header_", ""), 10)])
    } catch (e) {

    }

  })
  document.querySelectorAll(".suggest").forEach((el) => {

    let result = el.getElementsByTagName("a")
    if (result.length > 0) {
      el.getElementsByTagName("a")[0].classList.add("show-in-iframe")
    }
    let tag = document.createElement("span");


    tag.innerText = "مقاله پیشنهادی";
    tag.style.color = "#ff6600";
    tag.style.fontWeight = "bold";
    el.prepend(tag);
  });

  document.querySelectorAll(".x-text table, .article-container table, .blog-single__body table").forEach((table) => {
    const headers = Array.from(table.querySelectorAll("thead th")).map((th) => th.textContent.trim())
    if (!headers.length) {
      return
    }

    table.querySelectorAll("tbody tr").forEach((row) => {
      row.querySelectorAll("td").forEach((cell, index) => {
        if (!cell.getAttribute("data-label") && headers[index]) {
          cell.setAttribute("data-label", headers[index])
        }
      })
    })
  });
  document.addEventListener("mouseout", (event) => {

    if (event.target.classList.contains("show-in-iframe")) {
      isIframeHover = false
      setTimeout(function () {
        if (!isIframeHover) {
          let iframes = event.target.getElementsByClassName("popup-iframe")
          if (iframes.length > 0) {
            for (let i = 0; i < iframes.length; i++) iframes[i].remove()
          }
        }
      }, 500)
    }

    if (event.target.classList.contains("x-hint")) {
      isXHintOver = false
      setTimeout(function () {
        if (!isXHintOver) {
          let iframes = document.getElementsByClassName("popup-x-hint")
          if (iframes.length > 0) {
            for (let i = 0; i < iframes.length; i++) iframes[i].remove()
          }
        }
      }, 500)
    }

    if (event.target.classList.contains("popup-iframe")) {
      isIframeHover = false
      setTimeout(function () {
        if (!isIframeHover) {
          let iframes = document.getElementsByClassName("popup-iframe")
          if (iframes.length > 0) {
            for (let i = 0; i < iframes.length; i++) iframes[i].remove()
          }
        }
      }, 500)
    }

    if (event.target.classList.contains("popup-x-hint")) {
      isXHintOver = false
      setTimeout(function () {
        if (!isXHintOver) {
          let iframes = document.getElementsByClassName("popup-x-hint")
          if (iframes.length > 0) {
            for (let i = 0; i < iframes.length; i++) iframes[i].remove()
          }
        }
      }, 500)
    }

  })

  document.addEventListener("mouseover", (event) => {
    if (event.target.classList.contains("show-in-iframe")) {
      isIframeHover = true

      let target = event.target.getAttribute("href")
      event.target.style.position = "relative"
      let iframe = document.createElement("iframe")

      iframe.src = target
      iframe.style.position = "absolute"
      iframe.style.width = "500px"
      iframe.style.borderRadius = "12px"
      iframe.style.overflow = "hidden"
      iframe.style.height = "400px"
      iframe.style.maxWidth = "80vw"
      iframe.style.border = "0"
      iframe.classList.add("popup-iframe")
      iframe.addEventListener("mouseover", function () {
        isIframeHover = true
      })

      iframe.onload = function () {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        const body = iframeDoc.body;
        body.style.zoom = "10%";
      }


      iframe.style.left = "0"
      iframe.style.right = "0"
      iframe.style.margin = "auto"
      iframe.style.top = "-400px"
      event.target.appendChild(iframe)

    }


    if (event.target.classList.contains("x-hint")) {
      isXHintOver = true

      let text = event.target.getAttribute("data-description")
      event.target.style.position = "relative"
      let container = document.createElement("div")
      container.innerText = text
      container.style.position = "absolute"
      container.style.width = "300px"
      container.style.overflowY = "auto"
      container.style.borderRadius = "12px"
      container.style.overflow = "hidden"
      container.style.height = "200px"
      container.style.maxWidth = "80vw"
      container.style.border = "0"
      container.classList.add("popup-x-hint")
      container.addEventListener("mouseover", function () {
        isXHintOver = true
      })

      container.onload = function () {
        const iframeDoc = container.contentDocument || container.contentWindow.document;
        const body = iframeDoc.body;
        body.style.zoom = "10%";
      }


      container.style.left = "0"
      container.style.right = "0"
      container.style.margin = "auto"
      container.style.top = "-200px"
      event.target.appendChild(container)

    }
  })

});









